export default __webpack_public_path__ + "static/media/team2.12da4b16.jpg";